export const Toggle = ({
  checked = false,
  onChange,
  disabled = false,
  label,
  name = "toggle",
}) => {
  const handleChange = (e) => {
    if (disabled) return;
    onChange?.(e.target.checked);
  };

  return (
    <label
      className={`relative inline-flex items-center ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
    >
      <input
        name={name}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        aria-label={label || "Toggle"}
        className="sr-only peer"
      />
      <div
        style={{
          width: "44px",
          height: "24px",
          borderRadius: "9999px",
          backgroundColor: checked ? "#3F6212" : "#d1d5db",
          transition: "background-color 200ms ease-in-out",
          position: "relative",
        }}
      >
        <div
          style={{
            width: "20px",
            height: "20px",
            borderRadius: "9999px",
            backgroundColor: "#ffffff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
            position: "absolute",
            top: "2px",
            left: "2px",
            transform: checked ? "translateX(20px)" : "translateX(0)",
            transition: "transform 200ms ease-in-out",
          }}
        />
      </div>
    </label>
  );
};
